import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SPORTSBOOK_FULL_URL: DiToken<string | undefined> = new DiToken<string | undefined>('sportsbookFullUrl', {
  factory: () => undefined
});
